import { useInView } from "react-intersection-observer";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";

import { useCallback, useEffect, useRef, useState } from "react";
import { getDataFromSSR } from "@/handlers/client/commonClient";

import { useWindowSize } from "@/hooks/useIsMobile";
import GTMScript from "@/component/Ads/GTMScript";

import TabComponent from "./TvTab";
import VideoObjectSchema from "@/component/SeoTags/VideoObjectSchema";

const Breadcrumb = dynamic(() => import("@/component/Breadcrumb"));
const List1 = dynamic(() => import("@/component/Listing/VideoList1"));
const ItemsListSchema = dynamic(() => import("@/component/SeoTags/ItemsList"));
const List2 = dynamic(() => import("@/component/Listing/VideoList2"));
const BreadcrumbSchema = dynamic(() =>
  import("@/component/SeoTags/BreadcrumbSchema")
);
const HeadTag = dynamic(() => import("@/component/SeoTags/HeadTag"));

const NoData = dynamic(() => import("@/component/NoData"));
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));
const WebpageSchema = dynamic(() =>
  import("@/component/SeoTags/WebpageSchema")
);

const LiveTVPage = ({
  storyPageData = null,
  metaDescription = null,
  liveTV_id = null,
  faqData = null,
  description = "",
  title = "",
}) => {
  //   console.log("faqData", faqData);
  const [currentPage, setCurrentPage] = useState(0);
  const size = useWindowSize();
  const [videosData, setVideosData] = useState(
    storyPageData?.content ? storyPageData?.content : []
  );
  const [hasMore, setHasMore] = useState(true);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [y, setY] = useState(
    typeof window !== "undefined" && document.scrollingElement.scrollHeight
  );
  const [scrollDirection, setScrollDirection] = useState(
    "you have not scrolled yet"
  );

  const router = useRouter();

  const [insightref, insightView] = useInView({
    threshold: 0,
    rootMargin: "40%",
  });
  const [mobileInsightref, mobInsightView] = useInView({
    threshold: 0,
    rootMargin: "40%",
  });

  const handleNavigation = useCallback(
    (e) => {
      if (y > window.scrollY) {
        setScrollDirection("Scrolling Up");
      } else if (y < window.scrollY) {
        setScrollDirection("Scrolling Down");
      }
      setY(window.scrollY);
    },
    [y]
  );
  useEffect(() => {
    window.addEventListener("scroll", handleNavigation);

    return () => {
      window.removeEventListener("scroll", handleNavigation);
    };
  }, [handleNavigation]);

  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    function handleScroll() {
      if (!scrolled) {
        setScrolled(true);
      }
    }
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };

      if (window.screen.width < 900) {
        googletag.cmd.push(function () {
          {
            !scrolled && googletag.destroySlots();
          }
          // {
          //   !scrolled &&
          //     googletag
          //       .defineSlot(
          //         "/1007232/News_tak_Mobile_ROS_ATF_300x250",
          //         [300, 250],
          //         "div-gpt-ad-1659434453897-0"
          //       )
          //       .addService(googletag.pubads());
          // }
          if (scrolled) {
            if (videosData?.length > 7) {
              googletag
                .defineSlot(
                  "/1007232/News_tak_Mobile_ROS_MTF_300x250",
                  [300, 250],
                  "div-gpt-ad-1659434604998-0"
                )
                .addService(googletag.pubads());
            }
            // }

            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_BTF_300x250",
                [300, 250],
                "div-gpt-ad-1659435474737-0"
              )
              .addService(googletag.pubads());
          }

          {
            !scrolled &&
              googletag
                .defineSlot(
                  "/1007232/News_tak_Mobile_ROS_Bottom_320x50",
                  [320, 50],
                  "div-gpt-ad-1659435612077-0"
                )
                .addService(googletag.pubads());
          }

          // googletag.pubads().enableSingleRequest();
          googletag.enableServices();

          googletag.cmd.push(function () {
            var INTERSTITIALAd = googletag
              .defineOutOfPageSlot(
                "/1007232/News_tak_Mobile_ROS_Mweb_Interstitial",
                googletag.enums.OutOfPageFormat.INTERSTITIAL
              )
              .addService(googletag.pubads());

            googletag.display(INTERSTITIALAd);
          });
        });
      } else {
        googletag.cmd.push(function () {
          if (!scrolled) {
            googletag.destroySlots();
            // googletag
            //   .defineSlot(
            //     "/1007232/News_tak_Desktop_ROS_ATF_728x90",
            //     [728, 90],
            //     "div-gpt-ad-1659424515060-0"
            //   )
            //   .addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1707804176041-1"
              )
              .addService(googletag.pubads());
          }
          if (scrolled) {
            {
              videosData &&
                videosData?.length > 7 &&
                googletag
                  .defineSlot(
                    "/1007232/News_tak_Desktop_ROS_MTF_1_728x90",
                    [728, 90],
                    "div-gpt-ad-1707804176041-2"
                  )
                  .addService(googletag.pubads());
            }
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_BTF_728x90",
                [728, 90],
                "div-gpt-ad-1659425743360-0"
              )
              .addService(googletag.pubads());
          }
          // googletag.pubads().enableSingleRequest();
          googletag.enableServices();
        });
      }
    }, 10);

    try {
      // page query params
      const page = parseInt(router?.query?.page);
      if (page) {
        setCurrentPage(parseInt(page));
      }
    } catch (error) {
      console.error(error);
    }
  }, [scrolled]);
  useEffect(() => {
    if (
      (insightView || mobInsightView) &&
      scrollDirection == "Scrolling Down" &&
      hasMore
    ) {
      setCurrentPage(currentPage + 1);
    }
  }, [insightView, mobInsightView, scrollDirection]);
  const getMorePost = async () => {
    const websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
    setLoadingSpinner(true);
    const fetchedData = await getDataFromSSR(
      `${websiteUrl}/api/getStories?page=${currentPage}`
    );

    if (fetchedData?.data?.storyData?.content?.length > 0) {
      setVideosData([...videosData, ...fetchedData?.data?.storyData?.content]);
    } else {
      setHasMore(false);
    }
    setLoadingSpinner(false);
  };
  useEffect(() => {
    currentPage > 0 && !loadingSpinner && getMorePost();
    let height = window?.scrollY;
    window.scrollTo(0, height);
  }, [currentPage]);

  // console.log("VideoPage", latestVideoData);
  const isTvAds = false;

  const [isMobile, setIsMobile] = useState(false);

  const faqRef = useRef(null);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);


  const [fixTab, setFixTab] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const triggerHeight = 200; // or any threshold
      if (window.scrollY > triggerHeight) {
        setFixTab(true);
      } else {
        setFixTab(false);
      }
    };

    if (isMobile) {
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, [isMobile]);

  const tabStyle = isMobile && fixTab
    ? {
      position: "fixed",
      top: "60px", // your mobile header height
      left: 0,
      right: 0,
      zIndex: 1000,
      background: "#fff",
      padding: "10px 0",
    }
    : isMobile
      ? {
        position: "relative", // scrolls with content until trigger point
        zIndex: 1,
      }
      : {};




  return (
    <section>
      <HeadTag
        title={metaDescription?.title}
        description={metaDescription?.description}
        keywords={metaDescription?.keywords}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + router?.pathname}
        image={
          `https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/brand-logo-1-ns.png`
        }
      />
      <GTMScript />
      <WebpageSchema
        title={metaDescription?.title}
        description={metaDescription?.description}
        keywords={metaDescription?.keywords}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + router?.pathname}
      />

      <VideoObjectSchema
        title={metaDescription?.title}
        description={metaDescription?.description}
        image={ `https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/brand-logo-1-ns.png`}
        keywords={metaDescription?.keywords}
        canonical_url={process.env.NEXT_PUBLIC_WEBSITE_URL + router?.pathname}

      />
      <BreadcrumbSchema
        breadcrumbList={[
          {
            title: title,
            canonical_url: router?.pathname,
          },
        ]}
      />
      <ItemsListSchema data={storyPageData?.content} />
      <Breadcrumb
        breadcrumbList={[
          {
            title: title,
            canonical_url: router?.pathname,
            // icon: "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/livetv.svg",
          },
        ]}
      />
      {/* <VDOAdsScript /> */}

      <section className="mx-4 md:mx-4 md:px-2 py-2">
        {/* <AdSlot300x250
          divId="div-gpt-ad-1659434453897-0"
          minWidth="300px"
          minHeight="250px"
        />
        <AdSlot728x90
          divId="div-gpt-ad-1659424515060-0"
          minWidth="720px"
          minHeight="90px"
        /> */}
        {/* implement live tv tab */}
        <h1 className="text-2xl font-bold text-gray-800 "> {title} </h1>
        <div  >
          {/* <div   style={tabStyle} className="overflow-hidden"> */}
          <TabComponent liveTV_id={liveTV_id} />
          {/* </div> */}

          <div className="overflow-hidden" dangerouslySetInnerHTML={{ __html: description }} />
        </div>

        {faqData && (
          <section ref={faqRef}>
            <h2 class="text-xl font-semibold text-gray-800 mb-3 mt-3">
              {faqData?.title?.split("FAQ")} लाइव टीवी से जुड़े सवाल जवाब :
            </h2>
            <div
              className="text-gray-800"
              dangerouslySetInnerHTML={{
                __html: `${faqData?.content?.description_short}`,
              }}
            />
          </section>
        )}
        {size.width < 900 ? (
          <div>
            {" "}
            <List1
              title=""
              newsListData={videosData}
              isLCP={true}
              showAds={true}
              haveH1={false}
              isTvAds={isTvAds}
              scrolled={scrolled}
            />
            <div
              className="text-sports news-load h-[50px] w-full mb-4"
              ref={mobileInsightref}
            >
              {loadingSpinner === true && (
                <div className="flex items-center justify-center">
                  <div className="animate-spin rounded-full border-t-4 border-primary border-solid h-12 w-12"></div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div>
            {/* implement live tv tab */}

            <List2
              title=""
              newsListData={videosData}
              isLCP={true}
              haveH1={false}
              showAds={true}
              scrolled={scrolled}
            />
            <div
              className="h-[50px] w-full mb-4 text-sports news-load container-0"
              ref={insightref}
            >
              {loadingSpinner === true && (
                <div className="flex items-center justify-center">
                  <div className="animate-spin rounded-full border-t-4 border-primary border-solid h-12 w-12"></div>
                </div>
              )}
            </div>
          </div>
        )}
        {storyPageData?.content?.length === 0 && videosData?.length === 0 && (
          <NoData message="No Data Found" />
        )}

        {scrolled && (
          <AdSlot300x250
            divId="div-gpt-ad-1659435474737-0"
            minWidth="300px"
            minHeight="250px"
          />
        )}

        {scrolled && (
          <AdSlot728x90
            divId="div-gpt-ad-1659425743360-0"
            minWidth="720px"
            minHeight="90px"
          />
        )}
      </section>
    </section>
  );
};

export default LiveTVPage;
